// extracted by mini-css-extract-plugin
module.exports = {"InsideWrapper":"callToAction-module--InsideWrapper--2jlI4","Heading":"callToAction-module--Heading--2jxsY","SubHeading":"callToAction-module--SubHeading--2Dzh2"};